module.exports = __webpack_public_path__ + "img/skip-button.c2ee0164.png";